import React from 'react';

import * as styles from './styles.module.scss';

const Layout: React.FunctionComponent = ({ children }) => (
    <div className={styles['side_bar_wrapper']}>
        <div>{children}</div>
    </div>
);

export default Layout;
